import { useState, useEffect,useCallback } from "react";
import { useSelector, useDispatch  } from "react-redux";
import {
  addEmployeereport,
  getEmployeereports,
  getEmployeereport,
  editEmployeereport,
  deleteEmployeereport,
  getAllEmployeereports,
} from "../../store/actions/employeereport_action";
import _debounce from "lodash/debounce";
// import { useSelectAllIndustry } from "./UseIndustry";

// Get All Data
export const useAllEmployeereports = () => {
  const dispatch = useDispatch();
  const data = useSelector((state) => state.employeereport);
  const [pageNumber, setPageNumber] = useState(1);
  const [deleteEntry, setDeleteEntry] = useState(null);
 
  useEffect(() => {
    if (deleteEntry) {
      dispatch(deleteEmployeereport(deleteEntry));
  }
    allQuery();
  }, [deleteEntry, pageNumber, window.location.search]);
  const allQuery = useCallback(
    _debounce(() => {
     
      dispatch(
        getEmployeereports({
          pageNumber,
        })
      );
    }, 1000),
    []
  );

  useEffect(() => {
    setPageNumber(1);
  }, [window.location.search]);

  const deleteBtnClicked = async (id) => {
    setDeleteEntry(id);
  };

  return [
    data, setPageNumber, deleteBtnClicked
  ];
};

// Get Single Data
export const useSingleEmployeereport = (id) => {
  const dispatch = useDispatch();
  const data = useSelector((state) => state.employeereport);
  useEffect(() => {
    dispatch(getEmployeereport(id));
  }, [id]);
  return [data];
};
// Add Data
export const useCreateEmployeereport = () => {
  const dispatch = useDispatch();
  const data = useSelector((state) => state.employeereport);
  const addData = async (data) => {
    await dispatch(addEmployeereport(data));
  };
  return [data, addData];
};
export const useUpdateEmployeereport = () => {
  const dispatch = useDispatch();
  // const data = useSelector((state) => state.employeereport);
  const updateData = async (id, data) => {
    await dispatch(editEmployeereport(id, data));
  };
  return [updateData];
};

export const useSelectAllEmployeereport = () => {
  const dispatch = useDispatch();
  const [term, setTerm] = useState("");
  const [value, setValue] = useState("");
  const data = useSelector((state) => state.employeereport);
  useEffect(() => {
    dispatch(getAllEmployeereports({ term, value }));
  }, [term, value]);
  return [data, setTerm, setValue];
};


export const useGetDropdownOptions = () => {
  //  const [client, setClientSearchField, setClientSearchValue] =
    // useSelectAllClient();
 
  const [dropdownOptions, setDropdownOptions] = useState({});
  // useEffect(() => {
  //   if (industry && industry.all_industrys) {
  //     const newData = industry.all_industrys.map((item) => {
  //       return { label: item.name, value: item.name };
  //     });
  //     setDropdownOptions({ ...dropdownOptions, industry: newData });
  //   }
  // }, [industry]);
  const loadOptions = async (inputValue, callback, field) => {
    // if (field == "parent_category") {
    //   await setCategorySearchField("name");
    //   await setCategorySearchValue(inputValue);
    //   callback(dropdownOptions.parent_category);
    // }
  };

 
  return [dropdownOptions,loadOptions  ];
};